import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import { StepperProps } from 'types/Modal';

interface VerticalStepperProps {
    steps: StepperProps[];
    activeStep: number;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
}

export default function VerticalStepper({
    steps,
    activeStep,
    setActiveStep,
}: VerticalStepperProps) {
    const handleClick = (index: number) => {
        if (index < activeStep) setActiveStep(index);
    };
    return (
        <div className="max-h-[912px] ">
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step
                        key={`step-${index}`}
                        sx={{
                            '& .MuiStepLabel-root .MuiStepLabel-step': {
                                fontSize: 20, // step
                                fontWeight: 700,
                            },
                            '& .MuiStepLabel-root .MuiStepIcon-root': {
                                fill: '#0066F8', // icon
                                width: 40,
                                height: 40,
                                fontSize: 16,
                                fontWeight: 700,
                                marginLeft: '-8px',
                            },
                            '& .MuiStepLabel-step.Mui-active': {
                                color: '#0066F8', // step (ACTIVE)
                            },
                            '& .MuiStepLabel-step.Mui-disabled': {
                                color: '#CCE2FF', // step (DISABLED),
                            },
                            '& .MuiStepLabel-step.Mui-completed': {
                                color: '#004299', // step (COMPLETED),
                            },
                            '& .MuiStepLabel-root .Mui-disabled .MuiStepIcon-root':
                                {
                                    fill: '#CCE2FF', // icon (DISABLED)
                                },
                            '& .MuiStepLabel-root .Mui-completed .MuiStepIcon-root':
                                {
                                    fill: '#001965', // icon (COMPLETED)
                                },
                        }}
                    >
                        <StepLabel
                            onClick={() => handleClick(index)}
                            className="cursor-pointer"
                        >
                            <b className="text-true-blue text-xl">
                                {step.label}
                            </b>
                        </StepLabel>
                        <StepContent>{step.content}</StepContent>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
}
